import React from 'react';
import { CardStat, CardStatLabel, CardStatRow } from '../../../components/card-stat';

interface EmptyLongMetricProps {
  label: string;
}

export const EmptyLongMetric = React.forwardRef<HTMLDivElement, EmptyLongMetricProps>(({ label }, ref) => (
  <div ref={ref} className="space-y-2">
    <CardStatRow>
      <CardStat className="text-xl leading-none text-[#cbd1d7]">-</CardStat>
      <div className="flex items-center gap-1 text-xs text-[#cbd1d7]">
        <span>-%</span>
      </div>
    </CardStatRow>
    <CardStatLabel className="text-[#cbd1d7]">{label}</CardStatLabel>
  </div>
));

EmptyLongMetric.displayName = 'EmptyLongMetric';
